import { TEAMS_SORT_COLUMN_LABELS } from "@components/table/teams/teams-table-constants";
/** Default teams sort by option */
export const DEFAULT_TEAMS_SORT_BY = "name_ascending";

/** Maximum number of members per invite request supported by backend. */
export const MAX_INVITED_MEMBERS = 10;

/** Available teams sort field options */
export const TEAMS_SORT_OPTIONS = {
  name: {
    field: "name",
    label: TEAMS_SORT_COLUMN_LABELS.name
  },
  users: {
    field: "users",
    label: TEAMS_SORT_COLUMN_LABELS.users
  },
  creationDate: {
    field: "creationDate",
    label: TEAMS_SORT_COLUMN_LABELS.creationDate
  },
  workspaceRole: {
    field: "workspaceRole",
    label: TEAMS_SORT_COLUMN_LABELS.workspaceRole
  }
};

/** Map of the sort by options to the SortItem format */
export const TEAMS_SORT_BY_MAP = {
  ["name_ascending"]: {
    field: "name",
    sort: "asc"
  },
  ["name_descending"]: {
    field: "name",
    sort: "desc"
  },
  ["users_ascending"]: {
    field: "users",
    sort: "asc"
  },
  ["users_descending"]: {
    field: "users",
    sort: "desc"
  },
  ["creation_date_ascending"]: {
    field: "creationDate",
    sort: "asc"
  },
  ["creation_date_descending"]: {
    field: "creationDate",
    sort: "desc"
  },
  ["workspace_role_ascending"]: {
    field: "workspaceRole",
    sort: "asc"
  },
  ["workspace_role_descending"]: {
    field: "workspaceRole",
    sort: "desc"
  }
};